module.exports = __webpack_public_path__ + "static/media/6.2cd8f6c2.jpg";